import { IS_MOCK_MODE } from 'src/constants/featureFlag'
import { SERVER_URL } from 'src/constants/serverUrl'
import { TemplateFolder } from 'src/legacy_modules/entities/template-folder/entity'
import { requestPut } from 'src/legacy_modules/server/request'

import { fixtures } from '../../../../../../entities/template-folder/fixture'
import {
  parse,
  TemplateFolderResponse,
} from '../../../../../../entities/template-folder/request'

type SortTemplateFolderParam = {
  uid: string
  index: number
}

type SortTemplateFolderParams = {
  template_folders: SortTemplateFolderParam[]
}

export const submitSortTemplateFolder = async ({
  trialUid,
  params,
}: {
  trialUid: string
  params: SortTemplateFolderParams
}): Promise<TemplateFolder[]> => {
  if (IS_MOCK_MODE) {
    return fixtures
  }

  const resp = await requestPut<TemplateFolderResponse[]>({
    url: `${SERVER_URL}/trials/${trialUid}/template_folders/sort`,
    params: params,
  })

  return resp.data.map(parse)
}

export const toParams = (
  templateFolders: TemplateFolder[],
): SortTemplateFolderParams => {
  return {
    template_folders: templateFolders.map(tf => {
      return {
        uid: tf.uid,
        index: templateFolders.indexOf(tf),
      }
    }),
  }
}
